import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// users
import user1 from "../../../assets/images/users/avatar-1.jpg"
import { usePermissions } from "hooks"
import PasswordResetModal from "./components/PasswordResetModal"
import { useSelector } from "react-redux"
import { layoutModeTypes } from "constants/layout"
import Colors from "constants/Colors"

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)
  const [showPasswordModal, setShowPasswordModal] = useState(false)

  const [username, setusername] = useState("")
  const { showAll, permissions } = usePermissions("profile")
  const { permissions: authPermissions } = usePermissions("auth")

  const layoutMode = useSelector(state => state.Layout.layoutModeType)

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item d-flex align-items-center"
          id="page-header-user-dropdown"
          tag="button"
        >
          <span className="profile_img rounded-circle g_center">
            <i className="bx bxs-user text-white fs-5"></i>
          </span>
          {/* <img
            className="rounded-circle header-profile-user"
            src={user1}
            alt="Header Avatar"
          /> */}
          <span className="d-none d-xl-inline-block ms-2 me-1">{username}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {(showAll || permissions.includes("can_view_profile")) && (
            <>
              <Link
                to="/profile"
                className="dropdown-item"
                style={{
                  color:
                    layoutMode === layoutModeTypes.LIGHT
                      ? Colors.black
                      : Colors.white,
                }}
              >
                <i className="bx bx-user font-size-16 align-middle me-1" />
                {props.t("Profile")}{" "}
              </Link>
              <div className="dropdown-divider" />
            </>
          )}

          {(showAll || authPermissions.includes("can_change_password")) && (
            <>
              <Link
                to="#"
                onClick={() => setShowPasswordModal(true)}
                className="dropdown-item"
                style={{
                  color:
                    layoutMode === layoutModeTypes.LIGHT
                      ? Colors.black
                      : Colors.white,
                }}
              >
                <i className="bx bx-lock font-size-16 align-middle me-1" />
                {props.t("Change Password")}
              </Link>
              <div className="dropdown-divider" />
            </>
          )}

          <Link
            to="/logout"
            className="dropdown-item"
            style={{
              color:
                layoutMode === layoutModeTypes.LIGHT
                  ? Colors.black
                  : Colors.white,
            }}
          >
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
      {showPasswordModal && (
        <PasswordResetModal
          isOpen={showPasswordModal}
          toggle={() => setShowPasswordModal(!showPasswordModal)}
        />
      )}
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)
